import { render, staticRenderFns } from "./FollowUpConteudo.vue?vue&type=template&id=e4834fae&scoped=true"
import script from "./FollowUpConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUpConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FollowUpConteudo.vue?vue&type=style&index=0&id=e4834fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4834fae",
  null
  
)

export default component.exports